export default "__VITE_ASSET__CjiVHuVZ__"